import { render } from "./PugModal.vue?vue&type=template&id=0a701c22"
const script = {}

import exportComponent from "D:\\a\\1\\s\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_54cfde2c990ff210a7a99a11aeeefabf\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__